.card {
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 15px 16px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--panel);
  box-shadow: var(--shadow-wdg);
}

.kicker {
  color: var(--ink-3);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1.2;
  text-transform: uppercase;
}

.guest {
  color: var(--ink);
  font-size: 15px;
  font-weight: 650;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  color: var(--ink-3);
  font-size: 12px;
  line-height: 1.35;
}

.objectCode {
  color: var(--ink);
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 11.5px;
}

.stage {
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 999px;
  background: color-mix(in oklab, var(--accent) 12%, var(--tint-on));
  color: var(--accent);
  font-size: 11.5px;
  font-weight: 650;
  line-height: 1.2;
}

/* Правила `.assignee`/`.avatar`/`.assigneeText`/`.assigneeLabel`/`.assigneeName` жили здесь и убраны
   вместе с карточкой «Ответственный» — исполнителя у переписки нет как понятия (см. .tsx). */

.primary {
  height: 34px;
  margin-top: 2px;
  border: 0;
  border-radius: 8px;
  background: var(--ink);
  color: var(--bg);
  cursor: pointer;
  font: inherit;
  font-size: 12.5px;
  font-weight: 650;
}

.primary:hover {
  background: var(--accent);
  color: var(--on-accent);
}

.emptyIcon {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 10px;
  background: var(--sunk);
  color: var(--ink-3);
}

.emptyTitle {
  color: var(--ink);
  font-size: 13px;
  font-weight: 650;
}

.emptyText {
  color: var(--ink-3);
  font-size: 12px;
  line-height: 1.45;
}
